export const PRIMARY_STYLE_VARIANT = 'primary';
export const SECONDARY_STYLE_VARIANT = 'secondary';
export const SUCCESS_STYLE_VARIANT = 'success';
export const DANGER_STYLE_VARIANT = 'danger';
export const DEFAULT_STYLE_VARIANT = 'default';

export const styleVariants = [
    PRIMARY_STYLE_VARIANT,
    SECONDARY_STYLE_VARIANT,
    SUCCESS_STYLE_VARIANT,
    DANGER_STYLE_VARIANT,
    DEFAULT_STYLE_VARIANT,
] as const;

export type StyleVariant = (typeof styleVariants)[number];
